<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="库存对比" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<warehouse-input v-model="filterWarehouse"></warehouse-input>
						</div>
<!--						<div class="operator-col">-->
<!--							<classify-input v-model="filterClassify" size="mini"></classify-input>-->
<!--						</div>-->
<!--						<div class="operator-col">-->
<!--							<brand-input v-model="filterBrand"></brand-input>-->
<!--						</div>-->
<!--						<div class="operator-col">-->
<!--							<season-input v-model="filterSeason"></season-input>-->
<!--						</div>-->
<!--						<div class="operator-col">-->
<!--							<el-input-->
<!--								size="mini"-->
<!--								v-model="filterTableSearch"-->
<!--								placeholder="SPU 名/码"-->
<!--								suffix-icon="el-icon-search"-->
<!--								clearable-->
<!--							></el-input>-->
<!--						</div>-->
<!--						<div class="operator-col">-->
<!--							<el-input-->
<!--								size="mini"-->
<!--								v-model="filterTableSearchColor"-->
<!--								placeholder="颜色 名/码"-->
<!--								suffix-icon="el-icon-search"-->
<!--								clearable-->
<!--							></el-input>-->
<!--						</div>-->
<!--						<div class="operator-col">-->
<!--							<editor-relateid-->
<!--								size="mini"-->
<!--								v-model="filterModel"-->
<!--								data-model-name="Model"-->
<!--								:name-fields="['name']"-->
<!--								:params="{allowCreate:false,placeholder:'搜索尺寸'}"-->
<!--							></editor-relateid>-->
<!--						</div>-->
<!--            <div class="operator-col">-->
<!--              <el-select-->
<!--                  size="mini" v-model="filterMetagender.value" placeholder="请选择性别" @change="sexChange">-->
<!--                <el-option-->
<!--                    v-for="item in options"-->
<!--                    :key="item.value"-->
<!--                    :label="item.label"-->
<!--                    :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </div>-->
<!--						<div class="operator-col">-->
<!--							<bool-filter-->
<!--								size="mini"-->
<!--								v-model="filterIsCheck.value"-->
<!--								suffix-icon="el-icon-search"-->
<!--								clearable-->
<!--								data-model-name="Item"-->
<!--								field="is_check"-->
<!--								field-name="全部"-->
<!--							></bool-filter>-->
<!--						</div>-->

            <div class="operator-col">
              <el-input
                  size="mini"
                  v-model="filterTableSearch"
                  placeholder="SKU编码"
                  suffix-icon="el-icon-search"
                  clearable
              ></el-input>
            </div>

            <div class="operator-col">
              <el-button size="mini" type="success" @click="resetContrast()">重置盘点库存</el-button>
            </div>

            <div class="operator-col">
              <el-button size="mini" type="warning" @click="checkContrast()">筛选库存差异</el-button>
            </div>

            <div class="operator-col">
              <el-button size="mini" type="primary" @click="doContrastExport(editorDataModel)">导出差异库存</el-button>
            </div>
					</div>
					<sum-table
						ref="sumTable"
						:data-model="editorDataModel"
						:search-filter="filterTableSearch"
						:kv-filter="kvFilter"
						:fields="sumFields"
            @inputClear="inputClear"
						:warehouse-filter="filterWarehouse || {_id:''}"
						list-url="inventory/sum_all_stocks"
					></sum-table>
					<stock-contrast-table
						:list-ops="[]"
						:has-delete="false"
						ref="listTable"
						:data-model="editorDataModel"
						@doedit="handleEdit($event)"
						@dosort="handleSort"
						:search-filter="filterTableSearch"
						:kv-filter="kvFilter"
						:warehouse-filter="filterWarehouse"
            :warehouse-table="filterWaretable"
						list-url="inventory/list_all_stocks_contrast/"
					></stock-contrast-table>
				</div>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterSeason from "@/mixins/Filter/FilterSeason.js";
import FilterModel from "@/mixins/Filter/FilterModel.js";
import FilterClassify from "@/mixins/Filter/FilterClassify.js";
import FilterWarehouse from "@/mixins/Filter/FilterWarehouse.js";

import StockContrastTable from "@/views/Inventory/subs/StockContrastTable";
import SumTable from "@/components/SumTable.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import axios from "axios";

export default {
	mixins: [CurdPage, Filters, FilterSeason, FilterModel, FilterClassify, FilterWarehouse, StockContrastTable],
	components: {
		SumTable,
    StockContrastTable
	},
	data() {
		return {
      filterWaretable:'',
			loadings: {
				main: false,
				sums: false,
			},
      options: [{
        value: '',
        label: '全部'
      },{
        value: 0,
        label: '不区分性别'
      }, {
        value: 1,
        label: '男'
      }, {
        value: 2,
        label: '女'
      }],
      value:'',

			editorDataModel: "Item",
			filterIsSpecial: { field: "is_special", value: null },
			filterIsCheck: { field: "is_check", value: null },
      filterMetagender: { field: "meta_gender", value: null},

			filterTableSearchColor: "",
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),

		productFilters() {
			let filter = [];
			if (this.filterBrand._id != "") {
				filter.push({ k: "brand", t: "_id", v: this.filterBrand._id });
			}
			if (this.filterClassify.length != 0) {
				filter.push({
					k: "classify",
					t: "classify",
					v: this.filterClassify[this.filterClassify.length - 1]._id,
				});
			}
			return filter;
		},
		sumFields() {
			return [
				{
					name: "count",
					title: "种类",
				},
				{
					name: "sum_amount",
					title: "总数量",
				},
				{
					name: "sum_cost_total",
					title: "总金额",
					prefix: this.$root.currencyCode,
				},
			].filter(item => {
				if (!this.userPrivilegeMapping[59] && item.name == "sum_cost_total") {
					return false;
				}
				if (!this.userPrivilegeMapping[53] && item.name == "sum_amount") {
					return false;
				}
				return true;
			});
		},
	},
	watch: {
		"filterIsSpecial.value": {
			handler(newVal) {
				let val = this.filterIsSpecial;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, {
						k: val.field,
						t: "int",
						v: val.value,
					});
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true,
		},
    "filterMetagender.value": {
      handler(newVal) {
        let val = this.filterMetagender;
        console.log(this.filterMetagender)
        if (val.value != null && val.value !== "") {
          this.$set(this.kvFilter, val.field, {
            k: val.field,
            t: "int",
            v: val.value,
          });
        } else {
          this.$delete(this.kvFilter, val.field);
        }
      },
      immediate: true,
    },
	},
  methods:{
    inputClear(){
      if((this.filterTableSearch.length == 24 && this.filterTableSearch.substring(0, 2) != 'PD') ||this.filterTableSearch.length >= 26){
        this.filterTableSearch=''
      }
    },
    checkContrast(){
      this.filterWaretable=String(new Date().getTime())
      // const times=new Date().getTime()
      // console.log('时间戳',times)
      console.log('点击',this.filterWaretable)
    },
    sexChange(){
      console.log(1)
      this.$axios
          .post("/inventory/list_all_stocks/", {sex:1})
          .then(json => {
            console.log(json)
          })
          .catch(json => {
            console.log(json)
          });
    },

    resetContrast(){
      console.log(1)
      this.$axios
          .post("/inventory/reset_stocks_contrast")
          .then(json => {
            location. reload()
            this.$router.go(0)
            console.log(json)
          })
          .catch(json => {
            console.log(json)
          });
    },


  }
};
</script>
<style lang="scss" scoped>
</style>
